import React, { useState, useEffect, Fragment } from 'react';
import { ReactAuthWrapper } from '@carrier-sce-sharedpackages/reactauthwrapper';
import { useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistedStore } from 'redux/store';
import Home from '../home/index';
import Notification from '../common/notification';
import ConfirmationDialog from '../common/confirmation-dialog';
import Loader from '../common/loader';

import { umAuthConfig } from '../../configuration';
import { userContext } from '../../context/user';
import { NotificationProvider } from '../../context/notification';
import { ConfirmationProvider } from '../../context/confirmation';
import { LoaderProvider } from '../../context/loader';
import { BreadcrumbProvider } from '../../context/breadcrumb';

import { setGlobalUsers } from '../../redux/actions/user';
import { fetchBusinessUnitsAsync } from 'redux/business-units/business-units-actions';
import { fetchProductPlatformsAsync } from 'redux/product-platforms/product-platforms-actions';
import { getUsersFromPermission } from '../../services/user-management';

import './styles.css';

function App() {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState({});

  const userAuthCallback = (userDetails) => {
    setCurrentUser(userDetails);
  };

  const authorization = localStorage.getItem('msal.idtoken');

  useEffect(() => {
    if (authorization && authorization !== null) {
      getUsersFromPermission().then((res) => {
        dispatch(setGlobalUsers(res));
        dispatch(fetchBusinessUnitsAsync);
        dispatch(fetchProductPlatformsAsync);
      });
    }
  }, [authorization]);

  return (
    <PersistGate persistor={persistedStore}>
      <ReactAuthWrapper
        appConfig={umAuthConfig}
        getPermissions={userAuthCallback}
      >
        <Fragment>
          {currentUser.appAccess && (
            <userContext.Provider value={{ currentUser }}>
              <BreadcrumbProvider>
                <NotificationProvider>
                  <ConfirmationProvider>
                    <LoaderProvider>
                      <div className="App">
                        <Home />
                        <Notification />
                        <ConfirmationDialog />
                        <Loader />
                      </div>
                    </LoaderProvider>
                  </ConfirmationProvider>
                </NotificationProvider>
              </BreadcrumbProvider>
            </userContext.Provider>
          )}
        </Fragment>
      </ReactAuthWrapper>
    </PersistGate>
  );
}

export default App;
